import React from "react";
import {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import Cookies from 'js-cookie';
import { io } from "socket.io-client";

import './App.css';
import './output.css';

import sharedVariable from './global_v';

// npm install js-cookie
// npm install socket.io-client

const env1 = 'development';
const env2 = 'production';

var env = env2;

const currentURL = window.location.href;
if (!currentURL.includes('localhost')){
  env = 'production';
}

var temp_username = '';
var temp_password;
var temp_email;
var bind_email_str = '';
var temp_uid = 0;
var temp_nickname = '';
var temp_get_diamond_amount = 0;
var temp_total_spending = 0;
var temp_recommender = 0;

var temp_vip_time;
var temp_balance;

var temp_recommender2 = 0;
var temp_pay_amount = 0.01;

var send_verify_code = false;
var verifying = false;

// 防止频繁search
var last_search_time = 0;

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

var username;
var password;
var email;
var verify_code = "";

// 解绑邮箱需要二次确认
var confirm_count = 0;

var socket;

if (env === 'development'){
  socket = io.connect('http://localhost:5001',{
    path:"/socket.io/"
  });
}
else{
  socket = io.connect('https://bailanjo.cn',{
    path:"/socket.io/"
  });
}

var session_id = Cookies.get('session_id');

if (!session_id){
  socket.emit('get_session_id', '1');
  socket.once('session_id', function(data){
    session_id = data;

    var date = new Date();
    date.setTime(date.getTime() + (1*24*60*60*1000));

    // 需要设置过期时间，不然cookie会在浏览器关闭后自动消失！
    Cookies.set('session_id', session_id, {
      expires: date
    });
  });
}
else{
  socket.emit('check_session_id', session_id);
  socket.once('check_result', function(data){
    if (data === 'session expired'){
      alert('会话已过期，登录状态已失效！')

      socket.emit('get_session_id', '1');
      socket.once('session_id', function(data){
        session_id = data;

        var date = new Date();
        date.setTime(date.getTime() + (1*24*60*60*1000));

        Cookies.set('session_id', session_id, {
          expires: date
        });

        socket.disconnect();   
      });      
    }
    else{
      socket.emit('get_my_info', session_id);
      socket.once('info', function(data){
        temp_username = data[0].username;
        username = temp_username;
        temp_email = data[0].email;
        temp_uid = data[0].uid;
        temp_nickname = data[0].nickname;
        temp_get_diamond_amount = data[0].get_diamond_amount;
        temp_total_spending = data[0].total_spending;
        temp_recommender = data[0].recommender;

        socket.disconnect();      
      });  
    }
  }); 
}

if (!temp_email){
  bind_email_str = '未绑定邮箱';
}
else{
  bind_email_str = '已绑定邮箱';
}

var show_unbind_button = false;
if (bind_email_str === '已绑定邮箱'){
  show_unbind_button = true;
}

var update_info_interval;
var first_enter_user_page = false; 

// navigate时需要携带数据
var vip_remaining_time_str;
var temp_balance_brought;
var temp_email_brought;
var temp_uid_brought;
var temp_nickname_brought;
var temp_get_diamond_amount_brought;
var temp_total_spending_brought;
var temp_recommender_brought;

var get_no_info = false;

function get_uid_str(t_uid){
  if (t_uid){
    var t_uid_str = t_uid.toString();

    var temp_length = t_uid_str.length;
    if (temp_length <= 8){
      for(let i = 0;i < 8 - temp_length; i++){
        t_uid_str = '0' + t_uid_str;
      }
    }

    return t_uid_str;
  }
  else{
    return '00000000';
  }
}

const User = () => {
  const temp_count = useRef(0);
  const temp_count2 = useRef(0);

  const location = useLocation();
  // const { state } = useLocation();
  const navigate = useNavigate();

  const [temp_search_params] = useSearchParams();
  const search_once = temp_search_params.get('search_once');
  // console.log(state.search_once);

  const [nickname, setNickname] = useState(temp_nickname);
  const [changeClass, setChangeClass] = useState(false);
  const [redeemCode, setRedeemCode] = useState(''); // 兑换码
  const [autoCompleteUsername, setAutoCompleteUsername] = useState(temp_username);
  const [autoCompletePassword, setAutoCompletePassword] = useState(temp_password);
  const [autoCompleteNickname, setAutoCompleteNickname] = useState(temp_nickname);
  const [autoCompleteEmail, setAutoCompleteEmail] = useState(temp_email);
  const [info, setInfo] = useState({'vip_remaining_time':'', 'balance':0, 'uid':0, 'get_diamond_amount':0, 'total_spending':0, 'recommender':0});
  const [show, setShow] = useState(false)   // vip_remaining_time
  const [show2, setShow2] = useState(false) // balance/get_diamond_amount/total_spending
  const [show3, setShow3] = useState(false) // email
  const [show4, setShow4] = useState(false) // verify
  const [show5, setShow5] = useState(show_unbind_button) // unbind
  const [show6, setShow6] = useState(false) // refresh, sign in
  const [show7, setShow7] = useState(false) // recommender
  
  const [updateEmailStatus, setUpdateEmailStatus] = useState(false)

  // 首次进入user页面执行一次自动刷新
  if (!update_info_interval){
    first_enter_user_page = true;
    update_info_interval = setInterval(() => {
      if (temp_username !== '' && temp_username){
        clearInterval(update_info_interval);     
        auto_search(); 
        setTimeout(() => {
          setChangeClass(true);
        }, 200);

        setTimeout(() => {
          // 使用navigate强制进行渲染，defaultValue仅在首次渲染生效！
          // 不可以使用window.location.reload()，会一直刷新页面！
          navigate('/blank');
          setTimeout(() => {
            navigate('/user?search_once=true');     
          }, 10);
        }, 10);  
      }
    }, 10);  
  }

  // 切换路由时执行自动查询一次
  useEffect(()=>{
    // useRef 限制只执行一次
    if (temp_count2.current === 0){
      temp_count2.current = 1;

      email = temp_email;

      // 查询超时时间1秒
      setTimeout(() => {
        if (!temp_username || temp_username === ''){
          clearInterval(update_info_interval); 

          setNickname('visitor');

          setTimeout(() => {
            setChangeClass(true);
          }, 200);        
        }
      }, 1000);    

      async function delay_search() {
        if (first_enter_user_page){
          first_enter_user_page = false;
        }
        else{
          // 手动切换路由
          if (!search_once){
            if (!username && ! sharedVariable.login_status){
              temp_nickname = 'visitor';
              setShow6(false);
              setNickname('visitor');
            
              setTimeout(() => {
                setChangeClass(true);
              }, 200);
            }
            else{
              if (sharedVariable.login_status){
                setShow6(true);
                auto_search();
              }
            }
          }
          // 自动跳转不需要再次查询
          else{
            while (!vip_remaining_time_str && !temp_balance_brought && !temp_uid_brought && !temp_nickname_brought && !temp_get_diamond_amount_brought && !temp_get_diamond_amount_brought && !temp_recommender_brought){
              await sleep(10);
            }

            if (!get_no_info){
              setShow6(true);

              setInfo({'vip_remaining_time':vip_remaining_time_str, 'balance':temp_balance_brought, 
                'uid':temp_uid_brought, 'get_diamond_amount':temp_get_diamond_amount_brought, 
                'total_spending':temp_total_spending_brought, 'recommender':temp_recommender_brought})

              setNickname(temp_nickname_brought);

              setShow2(true);
              setShow3(true);

              if (temp_balance_brought > 0){
                setShow(false);
              }
              else{
                setShow(true);
              }

              if (temp_email_brought){
                bind_email_str = '已绑定邮箱';
                setUpdateEmailStatus(true);
                setShow5(true);                   
              }
              else{
                bind_email_str = '未绑定邮箱';
                setUpdateEmailStatus(true);
                setShow5(false);                               
              }   

              if (temp_recommender_brought){
                setShow7(true);
              }
              else{
                setShow7(false);
              }
            }
            else{
              setInfo({'vip_remaining_time':vip_remaining_time_str, 'uid':0, 'balance':0, 'get_diamond_amount':0, 'total_spending':0});

              setShow(true);
              setShow2(false);
              setShow3(false);              
            }           

            setTimeout(() => {
              setChangeClass(true);
            }, 200);
          }
        }        
      }

      delay_search();
    }
  },[location]);

  const update_recommender2 = (event) => {
    temp_recommender2 = event.target.value;
  }

  const update_pay_amount = (event) => {
    temp_pay_amount = event.target.value;
  }

  const update_redeem_code = (event) => {
    setRedeemCode(event.target.value);
  }

  const update_username = (event) => {
    username = event.target.value;
  }

  const update_password = (event) => {
    password = event.target.value;
  }

  const update_nickname = (event) => {
    setNickname(event.target.value);
  }

  const update_email = (event) => {
    email = event.target.value;
  }

  const update_verify_code = (event) => {
    verify_code = event.target.value;
  }
  
  function auto_search(){
    get_no_info = false;

    vip_remaining_time_str = null;
    temp_balance_brought = null;
    temp_email_brought = null;
    temp_uid_brought = null;
    temp_nickname_brought = null;
    temp_get_diamond_amount_brought = null;
    temp_total_spending = null;
    temp_recommender = null;

    // const socket = io.connect('https://bailanjo.cn/socket.io'); 是错误的！
    var socket;

    if (env === 'development'){
      socket = io.connect('http://localhost:5001',{
        path:"/socket.io/"
      });
    }
    else{
      socket = io.connect('https://bailanjo.cn',{
        path:"/socket.io/"
      });
    }

    socket.emit('get_user_info', [{'session_id': session_id, 'username':temp_username, 'password': ''}]);
    socket.once('get_user_info', function(msg){
      sharedVariable.login_status = true;
      sharedVariable.tip_username = temp_username;

      // 传来的msg是Object，不用JSON处理
      temp_vip_time = msg[0].vip_time;
      temp_balance = msg[0].balance;
      temp_email = msg[0].email;
      temp_uid = msg[0].uid;
      temp_nickname = msg[0].nickname;
      temp_get_diamond_amount = msg[0].get_diamond_amount;
      temp_total_spending = msg[0].total_spending;
      temp_recommender = msg[0].recommender;

      if (!temp_nickname){
        temp_nickname = '匿名用户';
      }

      sharedVariable.tip_nickname = temp_nickname;
      sharedVariable.tip_uid = temp_uid;

      var timestampInSeconds = Math.floor(new Date().getTime() / 1000);
      var vip_remaining_time = temp_vip_time - timestampInSeconds;

      if (vip_remaining_time > 0){
        var d = Math.floor(vip_remaining_time / 60 / 60 /24);
        var h = Math.floor((vip_remaining_time - d * 60 * 60 * 24) / 60 / 60);
        var m = Math.floor((vip_remaining_time -d * 60 * 60 * 24 - h * 60 * 60) / 60);
        var s = vip_remaining_time - d * 60 * 60 * 24 - h * 60 * 60 - m * 60;

        vip_remaining_time_str = `VIP剩余时间:${d}天${h}小时${m}分钟${s}秒`;
      }
      else{
        vip_remaining_time_str = `VIP剩余时间:${0}天${0}小时${0}分钟${0}秒`;              
      }

      setInfo({'vip_remaining_time':vip_remaining_time_str, 'balance':temp_balance, 
        'uid':temp_uid, 'get_diamond_amount':temp_get_diamond_amount, 
        'total_spending':temp_total_spending, 'recommender':temp_recommender});

      setShow2(true);
      setShow3(true);

      if (temp_balance > 0){
        setShow(false);
      }
      else{
        setShow(true);
      }

      if (temp_email){
        bind_email_str = '已绑定邮箱';
        setUpdateEmailStatus(true);
        setShow5(true);
      }
      else{
        bind_email_str = '未绑定邮箱';
        setUpdateEmailStatus(true);
        setShow5(false);            
      }

      if (temp_recommender){
        setShow7(true);
      }
      else{
        setShow7(false);
      }

      temp_balance_brought = temp_balance;
      temp_uid_brought = temp_uid;
      temp_nickname_brought = temp_nickname;
      temp_email_brought = temp_email;
      temp_get_diamond_amount_brought = temp_get_diamond_amount;
      temp_total_spending_brought = temp_total_spending;
      temp_recommender_brought = temp_recommender;

      socket.removeAllListeners('no_result');
      console.log('已移除事件监听器no_result');
      
      socket.disconnect();

      setTimeout(() => {
        setChangeClass(true);
      }, 200);   
    })

    socket.once('no_result', function(msg){
      get_no_info = true;
      temp_balance_brought = 0;

      if (msg === '没有找到该账号的信息'){
        vip_remaining_time_str = '该用户不存在！';

        username = temp_username;
        temp_nickname = 'visitor';
      }
      if (msg === '密码错误！'){
        vip_remaining_time_str = '密码错误！';
      }
      if (msg === '查询数据失败！'){
        vip_remaining_time_str = '查询数据失败！';
      }

      socket.removeAllListeners('get_user_info');
      console.log('已移除事件监听器get_user_info');
      socket.disconnect(); 
      
      setTimeout(() => {
        setChangeClass(true);
      }, 200);
    })      
  }

  function change_nickname(){
    if (sharedVariable.login_status){
      if (nickname !== temp_nickname){
        var socket;

        if (env === 'development'){
          socket = io.connect('http://localhost:5001',{
            path:"/socket.io/"
          });
        }
        else{
          socket = io.connect('https://bailanjo.cn',{
            path:"/socket.io/"
          });
        }

        socket.emit('change_nickname', [{'username':temp_username, 'nickname':nickname}])

        socket.once('change_nickname_result', function(msg){
          var temp_status = msg[0].status;

          if (temp_status === 'succeed'){
            temp_nickname = nickname;
            navigate('/blank');
            setTimeout(() => {
              navigate('/user');
            }, 10);  
          }
          else{
            alert('服务器异常，修改昵称失败！')
          }

          socket.disconnect();
        });
      }
      else{
        alert('当前昵称未发生变化！')
      }
    }
    else{
      alert('当前未登录，请登录后再修改昵称！');
    }
  }

  function search(){
    if (username !== '' && username){
      if (Math.floor(new Date().getTime() / 1000) - last_search_time > 1){
        last_search_time = Math.floor(new Date().getTime() / 1000);

        get_no_info = false;

        vip_remaining_time_str = null;
        temp_balance_brought = null;
        temp_email_brought = null;
        temp_uid_brought = null;
        temp_nickname_brought = null;
        temp_get_diamond_amount_brought = null;
        temp_total_spending_brought = null;
        temp_recommender_brought = null;

        // const socket = io.connect('https://bailanjo.cn/socket.io'); 是错误的！
        var socket;

        if (env === 'development'){
          socket = io.connect('http://localhost:5001',{
            path:"/socket.io/"
          });
        }
        else{
          socket = io.connect('https://bailanjo.cn',{
            path:"/socket.io/"
          });
        }

        socket.emit('get_user_info', [{'session_id': session_id, 'username':username, 'password': password}]);
        socket.once('get_user_info', function(msg){
          sharedVariable.login_status = true;
          
          temp_username = username;
          temp_password = password;
          temp_email = email;

          sharedVariable.tip_username = temp_username;

          // 传来的msg是Object，不用JSON处理
          temp_vip_time = msg[0].vip_time;
          temp_balance = msg[0].balance;
          temp_email = msg[0].email;
          temp_uid = msg[0].uid;
          temp_nickname = msg[0].nickname;
          temp_get_diamond_amount = msg[0].get_diamond_amount;
          temp_total_spending = msg[0].total_spending;
          temp_recommender = msg[0].recommender;

          if (!temp_nickname){
            temp_nickname = '匿名用户';
          }

          sharedVariable.tip_nickname = temp_nickname;
          sharedVariable.tip_uid = temp_uid;

          var timestampInSeconds = Math.floor(new Date().getTime() / 1000);
          var vip_remaining_time = temp_vip_time - timestampInSeconds;

          if (vip_remaining_time > 0){
            var d = Math.floor(vip_remaining_time / 60 / 60 /24);
            var h = Math.floor((vip_remaining_time - d * 60 * 60 * 24) / 60 / 60);
            var m = Math.floor((vip_remaining_time -d * 60 * 60 * 24 - h * 60 * 60) / 60);
            var s = vip_remaining_time - d * 60 * 60 * 24 - h * 60 * 60 - m * 60;

            vip_remaining_time_str = `VIP剩余时间:${d}天${h}小时${m}分钟${s}秒`;
          }
          else{
            vip_remaining_time_str = `VIP剩余时间:${0}天${0}小时${0}分钟${0}秒`;              
          }

          setInfo({'vip_remaining_time':vip_remaining_time_str, 'balance':temp_balance, 
            'uid':temp_uid, 'get_diamond_amount':temp_get_diamond_amount, 
            'total_spending':temp_total_spending, 'recommender':temp_recommender});    

          setShow2(true);
          setShow3(true);

          if (temp_balance > 0){
            setShow(false);
          }
          else{
            setShow(true);
          }

          if (temp_email){
            bind_email_str = '已绑定邮箱';
            setUpdateEmailStatus(true);
            setShow5(true);
          }
          else{
            bind_email_str = '未绑定邮箱';
            setUpdateEmailStatus(true);
            setShow5(false);            
          }

          if (temp_recommender){
            setShow7(true);
          }
          else{
            setShow7(false);
          }

          socket.removeAllListeners('no_result');
          console.log('已移除事件监听器no_result');
          
          socket.disconnect();

          temp_balance_brought = temp_balance;
          temp_uid_brought = temp_uid;
          temp_nickname_brought = temp_nickname;
          temp_email_brought = temp_email;
          temp_get_diamond_amount_brought = temp_get_diamond_amount;
          temp_total_spending_brought = temp_total_spending;
          temp_recommender_brought = temp_recommender;

          // 成功查询进行跳转
          // 使用navigate强制进行渲染，defaultValue仅在首次渲染生效！
          // 不可以使用window.location.reload()，会一直刷新页面！
          navigate('/blank');
          setTimeout(() => {
            navigate('/user?search_once=true');
          }, 10);      
        })

        socket.once('no_result', function(msg){
          get_no_info = true;
          temp_balance_brought = 0;

          if (msg === '没有找到该账号的信息'){
            vip_remaining_time_str = '该用户不存在！';

            username = temp_username;
            temp_nickname = 'visitor';         
          }
          if (msg === '密码错误！'){
            vip_remaining_time_str = '密码错误！';
          }
          if (msg === '查询数据失败！'){
            vip_remaining_time_str = '查询数据失败！';
          }

          socket.removeAllListeners('get_user_info');
          console.log('已移除事件监听器get_user_info');
          socket.disconnect(); 
          
          // 查询失败也进行跳转
          // 使用navigate强制进行渲染，defaultValue仅在首次渲染生效！
          // 不可以使用window.location.reload()，会一直刷新页面！
          navigate('/blank');
          setTimeout(() => {
            navigate('/user?search_once=true');
          }, 10);         
        })      
      }
      else
      {
        alert('搜索过于频繁！');
      }
    }
    else{
      alert('username字段不能为空！')
    }
  }

  async function bind(){
    if (!verifying){
      if (sharedVariable.login_status){
        function isValidEmail(temp_e) {
          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
          return emailRegex.test(temp_e);
        }    

        if (isValidEmail(email)){
          email = email.replace("@QQ", "@qq");

          const qq_email = /@qq\.com/;
          if (qq_email.test(email)){
            if (username !== ''){
              if (bind_email_str === '未绑定邮箱'){
                verifying = true;

                var socket;

                if (env === 'development'){
                  socket = io.connect('http://localhost:5001',{
                    path:"/socket.io/"
                  });      
                }
                else{
                  socket = io.connect('https://bailanjo.cn',{
                    path:"/socket.io/"
                  });
                }

                socket.emit('email_verify', [{'session_id': session_id, 'username':username, 'email':email}]);

                socket.once('already_bound', function(whose_email){
                  verifying = false;
                  alert('该邮箱已被绑定，绑定邮箱失败！');

                  if (whose_email === username){
                    bind_email_str = "已绑定邮箱";
                    setUpdateEmailStatus(true);
                    setShow5(true);
                  }
                });

                await sleep(2000);

                if (verifying){
                  setShow4(true);

                  socket.removeAllListeners('already_bound');
                  console.log('已移除事件监听器already_bound');  

                  alert('验证码已发送到你的邮箱，请尽快进行验证:)');
                  var temp_timer = setTimeout(() => {
                    socket.removeAllListeners('error');
                    console.log('已移除事件监听器error');  
                    
                    socket.disconnect(); 
                    verifying = false;    
                    
                    setShow4(false);
                    alert('本次验证失败，请重新验证！');                  
                  }, 300000);
                  
                  socket.once('verify_succeed', function(msg){
                    socket.removeAllListeners('verify_failed');
                    console.log('已移除事件监听器verify_failed');

                    socket.once('succeed', function(msg){
                      bind_email_str = '已绑定邮箱';
                      setUpdateEmailStatus(true);
                      setShow4(false);
                      setShow5(true);

                      socket.removeAllListeners('error');
                      console.log('已移除事件监听器error');

                      clearTimeout(temp_timer);
                      console.log('已移除定时器temp_timer');
                      socket.disconnect();  
                      
                      verifying = false;
                    });

                    socket.once('error', function(msg){
                      if (msg === '该用户已绑定过邮箱'){
                        alert('你已经绑定过邮箱了！');
                      }
                      if (msg === '更新数据失败'){
                        alert('服务器绑定邮箱失败，请重新尝试绑定邮箱！');
                      }
                      if (msg === '用户不存在'){
                        alert('数据库未能找到你的数据，绑定邮箱失败！')
                      }              
                      socket.removeAllListeners('succeed');
                      console.log('已移除事件监听器succeed');                       
                    });
                  });

                  socket.on('verify_failed', function(msg){
                    alert('验证码错误！');
                  })

                  async function wait_until_verify_over() {
                    while (verifying){
                      if (send_verify_code){
                        send_verify_code = false;
                                      
                        socket.emit('verify_code', verify_code);
                      }
                      await sleep(100);
                    }
                  }

                  await wait_until_verify_over();                
                }                
              }
              else{
                alert('你已经绑定过邮箱了！');
              }
            }
            else{
              alert('无效的用户名！');
            }
          }
          else{
            const pattern1 = /@qq/;
            if (!pattern1.test(email)){
              alert('目前只支持绑定QQ邮箱！');
            }
            else{
              alert('错误的QQ邮箱后缀');
            }
          }
        }
        else{
          alert('邮箱格式无效！');
        }
      }
      else{
        alert('请先按下search按钮登录账号！');
      }
    }
    else{
      alert('正在验证邮箱中，请不要重复验证邮箱！');
    }
  }

  function unbind(){
    if (sharedVariable.login_status){
      confirm_count += 1;
      if (confirm_count < 2){
        alert('如果你确定要解绑邮件的话，请再次点击unbind按钮')
      }
      else{
        confirm_count = 0;

        var socket;

        if (env === 'development'){
          socket = io.connect('http://localhost:5001',{
            path:"/socket.io/"
          });      
        }
        else{
          socket = io.connect('https://bailanjo.cn',{
            path:"/socket.io/"
          });
        }
      
        socket.emit('unbind_email', [{'session_id':session_id, 'username':username, 'email':email}]);

        socket.once('error', function(msg){
          alert('服务器解绑邮箱失败，请重新尝试解绑邮箱！');

          socket.removeAllListeners('succeed');
          console.log('已移除事件监听器succeed');
        });

        socket.once('succeed', function(msg){
          alert('解绑邮箱成功！');

          Cookies.remove('email');

          bind_email_str = '未绑定邮箱'
          setUpdateEmailStatus(true);
          setShow5(false);

          socket.removeAllListeners('error');
          console.log('已移除事件监听器error');
        });
      }
    }
    else{
      alert('请先按下search按钮登录账号！');
    }
  }

  function verify(){
    if (verify_code !== ''){
      send_verify_code = true;
    }
    else{
      alert('验证码不能为空！');
    }
  }

  function sign_in(){
    if (sharedVariable.login_status){
      var socket;

      if (env === 'development'){
        socket = io.connect('http://localhost:5001',{
          path:"/socket.io/"
        });
      }
      else{
        socket = io.connect('https://bailanjo.cn',{
          path:"/socket.io/"
        });
      }      

      socket.emit('sign_in', [{'session_id': session_id, 'username':temp_username, 'password': ''}]);
      socket.once('sign_in_succeed', function(msg){
        socket.removeAllListeners('sign_in_failed');
        console.log('已移除事件监听器sign_in_failed');

        var add_num = (msg - temp_balance_brought).toFixed(3);

        alert(`签到成功，余额增加${add_num}元:D`);

        // 这里没有search，需要去掉search_once=true重新search
        navigate('/blank');
        setTimeout(() => {
          navigate('/user');
        }, 10);  
        
        socket.disconnect();
      });

      socket.once('sign_in_failed', function(msg){
        socket.removeAllListeners('sign_in_succeed');
        console.log('已移除事件监听器sign_in_succeed');

        if (msg === '签到失败'){
          alert('服务器异常，签到失败，请重新尝试签到！');
        }
        if (msg === '今日已签到'){
          alert('今日已签到，请勿重复签到！');
        }
        if (msg === '未绑定邮箱'){
          alert('未绑定邮箱，无法签到！');
        }
        if (msg === '请刷新网页'){
          alert('服务器异常，请刷新网页！')
        }

        socket.disconnect();     
      });
    }
    else{
      alert('请先按下search按钮登录账号！');
    }
  }

  function use_redeem_code(){
    if (sharedVariable.login_status){
      if (redeemCode !== '' && redeemCode){
        var temp_url = '';

        if (env === 'development'){
          temp_url = `http://localhost:5001/use_code?username=${temp_username}&code=${redeemCode}`;
        }  
        else{
          temp_url = `https://bailanjo.cn/api/use_code?username=${temp_username}&code=${redeemCode}`;
        }

        fetch(temp_url)
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json(); // 或者 response.text() 根据你的需要
          })
          .then(data => {
            // 处理返回的数据
            if (data.status === 'succeed'){
              alert('兑换码使用成功！')
              
              // 这里没有search，需要去掉search_once=true重新search
              navigate('/blank');
              setTimeout(() => {
                navigate('/user');
              }, 10);       
            }
            else{
              if (data.data === '无效的兑换码'){
                alert('无效的兑换码！');
              }
              else{
                alert('服务器异常');
              }
            }                
          })
          .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
          }); 
        }
        else{
          alert('兑换码不能为空！');
        }       
    }
    else{
      alert('请先登录后再使用兑换码！')
    }
  }

  function bind_recommender(){
    var temp_int = parseInt(temp_recommender2);

    if (Number.isNaN(temp_int)){
      alert('填写的uid无法转换成数字！')
    }
    else{
      temp_recommender2 = parseInt(temp_recommender2)

      if (temp_username && temp_recommender2){
        if (temp_recommender2 !== temp_recommender){
          if (temp_recommender2 !== temp_uid){
            //var bind_recommender_url = `http://localhost:5001/api/bind_recommender?username=${temp_username}&recommender=${temp_recommender2}`;
            var bind_recommender_url = `https://bailanjo.cn/api/bind_recommender?username=${temp_username}&recommender=${temp_recommender2}`;

            fetch(bind_recommender_url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // 或者 response.text() 根据你的需要
            })
            .then(data => {
                var temp_status = data.status;

                if (temp_status === 'succeed'){
                  alert('绑定邀请人成功！');

                  navigate('/blank');
                  setTimeout(() => {
                    navigate('/user');     
                  }, 10);                
                }
                else{
                  var temp_message = data.message;

                  if (temp_message === '服务器异常'){
                    alert('服务器异常，绑定邀请人失败！');
                  }
                  if (temp_message === '邀请人异常'){
                    alert('该邀请人不存在/非官方邀请人！')
                  }            
                }   
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
          }
          else{
            alert('邀请人不能为自己！')
          }
        }
        else{
          alert('请勿绑定与上次一样的邀请人！')
        }
      }
      else{
        alert('邀请人uid不可为空！')
      }   
    }
  }

  function pay_directly(){
    var temp_int = parseInt(temp_pay_amount);

    if (Number.isNaN(temp_int)){
      alert('充值金额不为数字！')
    }
    else{
      if (temp_pay_amount <= 0){
        alert('充值金额不能<=0元！')
      }
      else if (temp_pay_amount > 648){
        alert('充值金额过大！')
      }
      else {
        if (temp_recommender){
          navigate(`/pay?username=${temp_username}&amount=${temp_pay_amount}&recommender=${temp_recommender}`); 
        }
        else{
          navigate(`/pay?username=${temp_username}&amount=${temp_pay_amount}`);        
        }
      }
    }
  }

  return(
    <div style={{minHeight:'30rem'}} className="flex bg-amber-50"> 
      <div style={{zIndex:'15', width: '30rem', minWidth: '30rem', minHeight:'calc(100lvh - 4rem)', paddingBottom:'0.5rem'}} className="relative bg-amber-50">
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'0.5rem', marginLeft: '0.5rem', marginTop: '2rem'}} className= "bg-amber-200 place-content-center grid">
          </div>
          <div style={{height:'3rem', width:'10rem', marginLeft: '1rem', marginTop: '2.75rem'}}>
            <div className="font2">
              账号
            </div>
          </div>          
        </div>        
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0 bg-amber-50" : "flex opacity-100 bg-amber-50"}>
          <div style={{height:'3rem', width:'16rem', marginLeft: '0.5rem'}} className="bg-amber-200">
            <input onChange={update_username} defaultValue={autoCompleteUsername} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写你的账号:)" className="focus:outline-0">
            </input>
          </div>
        </div>
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'0.5rem', marginLeft: '0.5rem', marginTop: '2rem'}} className= "bg-amber-200 place-content-center grid">
          </div>
          <div style={{height:'3rem', width:'10rem', marginLeft: '1rem', marginTop: '2.75rem'}}>
            <div className="font2">
              密码
            </div>
          </div>          
        </div>
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'16rem', marginLeft: '0.5rem'}} className="bg-amber-200">
            <input defaultValue={autoCompletePassword} type="password" onChange={update_password} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写你的密码:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={search} style={{height:'3rem', width:'5rem', marginLeft: '0.5rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              查询
            </div>
          </div>
        </div>         
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'0.5rem', marginLeft: '0.5rem', marginTop: '2rem'}} className= "bg-amber-200 place-content-center grid">
          </div>
          <div style={{height:'3rem', width:'10rem', marginLeft: '1rem', marginTop: '2.75rem'}}>
            <div className="font2">
              昵称
            </div>
          </div>          
        </div>
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'16rem', marginLeft: '0.5rem'}} className="bg-amber-200">
            <input defaultValue={autoCompleteNickname} onChange={update_nickname} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此输入你的昵称:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={change_nickname} style={{height:'3rem', width:'5rem', marginLeft: '0.5rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              更换
            </div>
          </div>
        </div> 
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'0.5rem', marginLeft: '0.5rem', marginTop: '2rem'}} className= "bg-amber-200 place-content-center grid">
          </div>
          <div style={{height:'3rem', width:'10rem', marginLeft: '1rem', marginTop: '2.75rem'}}>
            <div className="font2">
              邮箱
            </div>
          </div>          
        </div>        
        <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{height:'3rem', width:'16rem', marginLeft: '0.5rem'}} className="bg-amber-200">
            <input defaultValue={autoCompleteEmail} onChange={update_email} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写你的邮箱:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={bind} style={{height:'3rem', width:'5rem', marginLeft: '0.5rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              绑定
            </div>
          </div>
          <div className={ show5 ? "" : "hidden"}>
            <div onClick={unbind} style={{height:'3rem', width:'5rem', marginLeft: '0.5rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
              <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
                解绑
              </div>
            </div>  
          </div>                   
        </div>
        <div className={ show4 ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
            <div style={{height:'3rem', width:'0.5rem', marginLeft: '0.5rem', marginTop: '2rem'}} className= "bg-amber-200 place-content-center grid">
            </div>
            <div style={{height:'3rem', width:'10rem', marginLeft: '1rem', marginTop: '2.75rem'}}>
              <div className="font2">
                验证码
              </div>
            </div>          
          </div>        
          <div style={{transition:'opacity 1s ease'}} className={ !changeClass ? "flex opacity-0" : "flex opacity-100"}>
            <div style={{height:'3rem', width:'16rem', marginLeft: '0.5rem'}} className="bg-amber-200">
              <input onChange={update_verify_code} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写验证码:)" className="focus:outline-0">
              </input>
            </div>
            <div onClick={verify} style={{height:'3rem', width:'5rem', marginLeft: '0.5rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
              <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
                验证
              </div>
            </div>          
          </div>          
        </div>                
      </div>      
      <div style={{zIndex:'15', minWidth: '50rem', transition:'opacity 1s ease'}} className={ !changeClass ? "relative opacity-0 bg-amber-50" : "relative opacity-100 bg-amber-50"}>
        <div className={ show6 ? "flex" : "hidden"}>
          <div onClick={search} style={{height:'3rem', width:'5rem', marginLeft: 'calc(100% - 50rem)', marginTop:'2rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              刷新
            </div>
          </div>  
          <div onClick={sign_in} style={{height:'3rem', width:'5rem', marginLeft: '2rem', marginTop:'2rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              签到
            </div>
          </div>  
          <div style={{marginLeft: '2rem', marginTop:'2rem', height:'3rem', width:'16rem'}} className="bg-amber-200">
            <input onChange={update_redeem_code} style={{height:'3rem', width:'19rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写兑换码:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={use_redeem_code} style={{marginLeft: '0.5rem', marginTop:'2rem', height:'3rem', width:'6rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt'}}>
              使用兑换码
            </div>
          </div>                          
        </div>              
        <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
          hello&nbsp;&nbsp;{nickname}!
        </div>
        <div className={ show2 ? "bg-amber-50 flex" : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            uid:{get_uid_str(info.uid)}
          </div>    
          <div style={{marginLeft: '2rem', marginTop:'2rem', height:'3rem', width:'11rem'}} className="bg-amber-200">
            <input onChange={update_recommender2} style={{height:'3rem', width:'10rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写邀请人uid:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={bind_recommender} style={{marginLeft: '0.5rem', marginTop:'2rem', height:'3rem', width:'6rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              绑定
            </div>
          </div>           
        </div>
        <div className={ show7 ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            邀请人uid:{get_uid_str(info.recommender)}
          </div>    
        </div>                  
        <div className={ show ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            {info.vip_remaining_time}
          </div>  
        </div>
        <div className={ show2 ? "bg-amber-50 flex" : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            余额:{info.balance}元
          </div> 
          <div style={{marginLeft: '2rem', marginTop:'2rem', height:'3rem', width:'10rem'}} className="bg-amber-200">
            <input onChange={update_pay_amount} style={{height:'3rem', width:'9rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写充值金额:)" className="focus:outline-0">
            </input>
          </div>
          <div onClick={pay_directly} style={{marginLeft: '0.5rem', marginTop:'2rem', height:'3rem', width:'6rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
            <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
              充值
            </div>
          </div>                
        </div>    
        <div className={ show2 ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            累计获得的钻石数量:{info.get_diamond_amount}
          </div>    
        </div>   
        <div className={ show2 ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            累计消费:{info.total_spending}元
          </div>    
        </div>              
        <div className={ show3 ? "bg-amber-50 " : "bg-amber-50 hidden"}>
          <div style={{height:'3rem', marginLeft: 'calc(100% - 50rem)', marginTop: '0.5rem', marginTop: '2rem', fontFamily: 'Hello Headline, lyt', fontSize: '36px'}}>
            {bind_email_str}
          </div>  
        </div>                
      </div>
    </div>
  )
}

export default User;